import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TalukService } from '../taluk.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { District } from '../../agent/agent-interface.service';
import { GlobalService } from 'src/app/global.service';
@Component({
  selector: 'app-taluk-register',
  templateUrl: './taluk-register.component.html',
  styleUrls: ['./taluk-register.component.scss']
})

export class TalukRegisterComponent implements OnInit {


  taluk_register_form: FormGroup;
  action: string = '';
  districts: District[] = [];
  constructor(private formBuilder: FormBuilder, private talukService : TalukService, private http: HttpService, private global: GlobalService) {
    this.getDistricts();
    this.taluk_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      district_id: [null, Validators.compose([Validators.required])],
    })

    if (this.talukService.get_taluk_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.talukService.get_taluk_data);
    }

    this.talukService.TalukUpdate.subscribe((relation_data) => {
      if (relation_data === null) {
        this.action = 'register';
        this.taluk_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(relation_data);
      }
    });

    this.talukService.TalukUpdate.subscribe((relation_type) => {
      this.setupUpdateForm(relation_type);
    });

   }

   getDistricts() {
    this.http.getDistrict().subscribe((data: District[]) => {
      console.log(data);
      this.districts = data;
    }, (error) => {
      console.log(error);
    });
  }

   setupUpdateForm(taluk) {
    this.taluk_register_form.controls['id'].setValue(taluk['id']);
    this.taluk_register_form.controls['name'].setValue(taluk['name']);
    this.taluk_register_form.controls['district_id'].setValue(taluk['district_id']);
   }

   registerTaluk() {
    const taluk_data = Object.assign({}, this.taluk_register_form.value);
    console.log(taluk_data)
    this.http.registerTaluk(taluk_data).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.taluk_register_form.reset();
      this.talukService.downloadTaluk.emit(true);
    });
  }

  ngOnInit() {
  }

}
